/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ExamAttemptStatus } from './examAttemptStatus';

export type ModuleExamAttempt = ExamAttemptStatus | null;
